import React, { Component } from "react";
import styled from "styled-components";

import { CButton, Flex, H4, P } from "@appcues/component-library";

export class ProductLedCardItem extends Component {
  onClickCardItem = () => {
    const { onClickProductLedFlowItem, productLedFlow } = this.props;
    onClickProductLedFlowItem(
      productLedFlow.userLifecycleStage,
      productLedFlow.name
    );
  };

  render() {
    const { className, productLedFlow } = this.props;
    return (
      <Flex
        flexDirection="column"
        alignItems="center"
        className={className}
        onClick={this.onClickCardItem}
      >
        <Flex
          alignItems="center"
          justifyContent="center"
          className="productLedFlowScreenshot"
          background={productLedFlow.gradient}
        >
          <div className="overlayContainer">
            <CButton type="positive" className="makeThisButton">
              Make this
            </CButton>
          </div>
          <img alt="Make this" src={productLedFlow.screenshotUrl} />
        </Flex>

        <Flex flexDirection="column" flexGrow="1" className="lifecycleMetadata">
          <Flex flexDirection="column">
            <H4>{productLedFlow.name}</H4>
            <P lineHeight={1.7}>{productLedFlow.description}</P>
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

const StyledProductLedCardItem = styled(ProductLedCardItem)`
  border: 1px solid ${({ theme }) => theme["$gray-2"]};
  border-radius: 6px;
  cursor: pointer;

  .productLedFlowScreenshot {
    border-radius: 6px 6px 0px 0px;
    padding: 1rem;
    height: 144px;
    width: 100%;

    img {
      height: 100%;
    }

    .overlayContainer {
      z-index: 1;
      display: none;
      position: absolute;
      font-weight: bold;

      .makeThisButton {
        background: rgba(255, 255, 255, 0.3);

        &:hover {
          background: rgba(255, 255, 255, 0.4);
        }
      }
    }
  }

  &:hover {
    box-shadow: ${({ theme }) => theme["$box-shadow-2"]};
    transition: box-shadow 0.35s ease;

    .productLedFlowScreenshot {
      background: rgba(36, 42, 53, 0.8);

      img {
        opacity: 0.2;
        filter: blur(3px);
        transition: all 250ms;
        -webkit-transition: all 250ms;
      }

      .overlayContainer {
        display: block;
      }
    }
  }

  .lifecycleMetadata {
    padding: 1em;
  }
`;
StyledProductLedCardItem.displayName = "ProductLedCardItem";

export default StyledProductLedCardItem;
